import { render, staticRenderFns } from "./Pagos2Crear.vue?vue&type=template&id=2983d5bc"
import script from "./Pagos2Crear.vue?vue&type=script&lang=js"
export * from "./Pagos2Crear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports